import axios from "@/utils/axios";

export default async function () {
  const response = await axios.get(`/payment-methods`);

  const payment = response.data;

  return payment;
}
